import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck} = FiIcons;

const BookingSection = () => {
  return (
    <section id="booking-section" className="pt-20 pb-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center">
        <a
          style={{color: 'rgb(255,255,255)'}}
          href="https://meetings-na2.hubspot.com/geospaceweb/call"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-full sm:w-auto bg-brand-600 hover:bg-brand-700 text-white text-lg font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5 mb-6"
        >
          Choose a Time to Get Started
        </a>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-medium text-slate-600 mb-14">
          {['No credit card required', '30-day free trial', 'Cancel anytime'].map((text, i) => (
            <div key={i} className="flex items-center gap-1.5">
              <div className="bg-green-100 rounded-full p-0.5">
                <SafeIcon icon={FiCheck} className="w-3.5 h-3.5 text-green-600" strokeWidth={3} />
              </div>
              <span>{text}</span>
            </div>
          ))}
        </div>

        <div className="bg-brand-50 border border-brand-100 rounded-2xl w-full max-w-2xl py-8 px-6 shadow-sm">
          <h3 className="text-brand-800 text-xl font-bold mb-3">Have a question before booking?</h3>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-slate-700 font-medium">
            <span>
              Call or Text:{' '}
              <a href="tel:5122003445" className="text-brand-600 hover:text-brand-800 transition-colors">
                512-200-3445
              </a>
            </span>
            <span className="hidden sm:block text-brand-300 text-lg leading-none">•</span>
            <span>
              Email:{' '}
              <a href="mailto:support@geospaceweb.com" className="text-brand-600 hover:text-brand-800 transition-colors">
                support [at] geospaceweb.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;